import {Request} from "kaiju.core";

const contentRootLoader = async (props: any) => {
    return await Request('CollectionGui.get', {id: props.params.collectionId}).then((resp: any) => {
        return resp.result
    })
};

export {contentRootLoader};